module.exports = __webpack_public_path__ + "img/56-l.1c19b502.png";